const values = [
  {
    title: "Accuracy first",
    text: "Every consolidation, rollup, and export is built to match the numbers your accountants already trust — no silent rounding, no dropped line items.",
  },
  {
    title: "Built for real org charts",
    text: "Holding companies, franchises, and portfolios rarely map to a single QuickBooks file. QAP was designed around that reality from day one.",
  },
  {
    title: "Transparent by design",
    text: "You can always see how a total was built — drill into any line item, at any level, back to the entity it came from.",
  },
];

function AboutUs() {
  return (
    <section id="about" className="about-section">
      <div className="about-inner">
        <div className="about-copy">
          <span className="section-eyebrow">About Us</span>
          <h2>Financial infrastructure for multi-entity organizations</h2>
          <p>
            QAP Financials started with a simple frustration: closing the
            books across multiple entities meant exporting reports from
            QuickBooks one company at a time, then manually stitching them
            together in Excel every single month.
          </p>
          <p>
            We build the layer that should have existed all along —
            consolidated, audit-ready financial reporting that stays in sync
            with QuickBooks and respects the way finance teams actually work.
          </p>
        </div>

        <div className="about-values">
          {values.map((v) => (
            <div className="about-value-item" key={v.title}>
              <h4>{v.title}</h4>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
